import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";
import { Header } from "./components/landing/Header";
import { Hero } from "./components/landing/Hero";
import { Journey } from "./components/landing/Journey";
import { WhyAttend } from "./components/landing/WhyAttend";
import { NextChapter } from "./components/landing/NextChapter";
import { Experience } from "./components/landing/Experience";
import { EventDetails } from "./components/landing/EventDetails";
import { FinalCta } from "./components/landing/FinalCta";
import { Footer } from "./components/landing/Footer";

function App() {
  const handleReserve = () => {
    toast("Terima kasih atas minat anda!", {
      description:
        "Butang ini masih dummy buat masa ini — hubungan admin akan diaktifkan tidak lama lagi.",
    });
  };

  return (
    <div className="min-h-screen bg-fira-deep text-white antialiased">
      <Header onReserve={handleReserve} />
      <main>
        <Hero onReserve={handleReserve} />
        <Journey />
        <WhyAttend onReserve={handleReserve} />
        <NextChapter />
        <Experience onReserve={handleReserve} />
        <EventDetails onReserve={handleReserve} />
        <FinalCta onReserve={handleReserve} />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
